import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { scrollToId } from '@/hooks/useLenis';

const StickyCta = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY;
            const h = document.documentElement.scrollHeight - window.innerHeight;
            // Hide near top and very bottom (form/footer)
            const nearBottom = y > h - 300;
            setVisible(y > 700 && !nearBottom);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-4 left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:bottom-6 z-30 md:w-auto"
                >
                    <div
                        className="mx-auto flex flex-wrap items-center justify-between gap-3 rounded-full border border-white/12 bg-black/85 backdrop-blur-xl pl-5 pr-2 py-2 shadow-2xl"
                        style={{ boxShadow: '0 30px 60px -20px rgba(0,0,0,0.7)' }}
                    >
                        <div className="flex items-center gap-3">
                            <span className="relative flex h-2.5 w-2.5">
                                <span className="absolute inline-flex h-full w-full rounded-full bg-[color:var(--brand)] opacity-75 animate-ping" />
                                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[color:var(--brand)]" />
                            </span>
                            <span className="text-xs md:text-sm text-white font-medium">
                                <span className="hidden md:inline">Cupos limitados · Primera edición individual · </span>
                                <span className="text-white/70">Cierra Sep 30</span>
                            </span>
                        </div>
                        <button
                            data-testid="sticky-cta-book"
                            onClick={() => scrollToId('sesion')}
                            className="inline-flex items-center gap-2 rounded-full bg-[color:var(--brand)] px-4 py-2.5 text-[11px] md:text-xs font-bold uppercase tracking-[0.14em] text-white hover:brightness-110 transition"
                        >
                            Agendar sesión
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default StickyCta;
